module.exports = __webpack_public_path__ + "img/bird_thumb.bfdf5698.jpg";